<template>
    <div class="col-md-6">
        <div class="shop_item shop_item-common"
             :style="{ backgroundImage: this.backgroundImage }"
             :class="backgroundImage ? 'shop_item-common-colored' : ''"
        >
            <div v-if="item.badge !== undefined"
                 class="shop_item-common_badge shop_item-badge"
                 :class="'badge-'+this.item.badge.color"
            >
                {{this.item.badge.text}}
            </div>
            <div class="shop_item-common_header">
                <div class="shop_item-common_title">
                    {{this.item.name}}
                </div>
                <div class="shop_item-common_duration">
                    {{this.item.duration}}
                </div>
            </div>
            <div class="shop_item-common_params">
                <ul>
                    <li v-if="this.item.visits_limit > 0">{{this.visits}}</li>
                    <li v-if="this.item.visits_limit === null">любое количество тренировок</li>
                    <li v-if="this.item.freeze_days > 0">{{this.freezeDays}}</li>
                </ul>
            </div>
            <div class="shop_item-common_price">
                <currency-symbol :price="this.item.price"/>

                <div class="shop_item-common_price-label" v-if="isCredit">
                    Доступно в рассрочку
                </div>

                <div class="shop_item-common_price-label shop_item-common_price-label-reccurent" v-if="isReccurent">
                    <currency-symbol :price="this.item.reccurent.price"/>/{{ reccurentPeriodLabel }} по подписке
                </div>
            </div>
            <div class="shop_item-common_btn btn btn-square"
                 @click="openContract(this.item.id)"
            >
                {{this.buttonText}}
            </div>
        </div>
    </div>
</template>

<script>

    import {plural} from "../../utilities";
    import api from "../../api";
    import CurrencySymbol from "../CurrencySymbol";

    export default {
        name: "ShopContractItem",
        components: {CurrencySymbol},
        props: {
            item: {},
        },
        computed: {
            backgroundImage: function () {
                return this.item.view_settings.background_color
                    ? 'url(' + require('@/assets/img/contract_'+this.item.view_settings.background_color+'.png') + ')'
                    : ''
            },
            visits() {
                return plural(this.item.visits_limit, ['посещение', 'посещения', 'посещений'])
            },
            freezeDays() {
                return plural(this.item.freeze_days, ['день', 'дня', 'дней']) + ' заморозки'
            },
            isReccurent() {
                return this.item.reccurent.enable !== undefined ? this.item.reccurent.enable : false
            },
            reccurentPeriodLabel() {
              return (this.item.duration || '').replace(/^1 /, '');
            },
            isCredit() {
                return this.item.credit.enable !== undefined ? this.item.credit.enable : false
            },
            buttonText() {
                return this.isReccurent ? 'Купить по подписке' : 'Купить'
            }
        },
        methods: {
            async openContract(itemId) {
                this.$store.commit('SHOW_MODAL_PRELOADER')
                let item = (await api.shop.getCatalogContract(itemId)).data;
                this.$store.commit('SET_SHOP_ITEM_CONTRACT_MODAL', item)
                this.$store.commit('HIDE_MODAL_PRELOADER')
            },
        },
    }
</script>